export function absRound(num) {
    return num < 0 ? Math.round(num * -1) * -1 : Math.round(num);
}
//# sourceMappingURL=abs-round.js.map


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/node_modules/ngx-bootstrap/chronos/utils/abs-round.js
// module id = ../../../../ngx-bootstrap/chronos/utils/abs-round.js
// module chunks = vendor